// Texts carousel — dot/arrow controls + scroll-driven dot sync
(function () {
  var track = document.getElementById('bb-texts-track');
  if (!track) return;
  var prevBtn = document.getElementById('bb-texts-prev');
  var nextBtn = document.getElementById('bb-texts-next');
  var dotsWrap = document.getElementById('bb-texts-dots');
  var cards = Array.from(track.children);

  // Build dots dynamically from card count
  cards.forEach(function (_, i) {
    var dot = document.createElement('button');
    dot.className = 'dot' + (i === 0 ? ' is-active' : '');
    dot.dataset.idx = i;
    dot.setAttribute('aria-label', 'Slide ' + (i + 1));
    dotsWrap.appendChild(dot);
  });
  var dots = Array.from(dotsWrap.children);

  function goTo(idx) {
    var target = cards[idx];
    if (!target) return;
    track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }
  function activeIdx() {
    var min = Infinity, idx = 0;
    cards.forEach(function (c, i) {
      var d = Math.abs(c.offsetLeft - track.scrollLeft - track.offsetLeft);
      if (d < min) { min = d; idx = i; }
    });
    return idx;
  }
  function syncDots() {
    var i = activeIdx();
    dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
  }

  dots.forEach(function (d) {
    d.addEventListener('click', function () { goTo(parseInt(d.dataset.idx, 10)); });
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(Math.max(0, activeIdx() - 1)); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(Math.min(cards.length - 1, activeIdx() + 1)); });
  track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
})();
